import {PassportUserLocale} from './types'

export const MAX_USERS_BEFORE_SCROLL = 4
export const DEFAULT_AVATAR_ID = '0/0-0'
export const DEFAULT_SERVICE = 'taxi'
export const PASSPORT_TRANLSATE: PassportUserLocale = {
  addUser: 'Добавить пользователя',
  signin: 'Войти',
  signout: 'Выйти',
  error: 'Ошибка',
}
